import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-add-orders',
  templateUrl: './admin-add-orders.component.html',
  styleUrls: ['./admin-add-orders.component.css']
})
export class AdminAddOrdersComponent implements OnInit {

  constructor(private matdialogref: MatDialogRef<AdminAddOrdersComponent>) { }

  ngOnInit(): void {
  }
  close() {
    this.matdialogref.close()
  }

}
